import { matchDeadline, type ScoreState } from '@aiscoreboard/contracts';
import { Countdown } from './Countdown';
import { useT } from '../lib/i18n';

interface Props {
  state: ScoreState;
}

/**
 * The match countdown, shown only when a limit was set at the start.
 *
 * All this does is work out the deadline from the event log — the ticking and
 * the pill itself are `Countdown`, which practice uses too. Deriving the
 * moment rather than being told it is what lets two devices watching the same
 * match agree without the server sending a single clock message.
 */
export function MatchClock({ state }: Props) {
  const t = useT();
  return (
    <Countdown
      deadline={matchDeadline(state)}
      title={t('clock.limit', { n: state.timeLimitMinutes ?? 0 })}
    />
  );
}
